module.exports = {
	"title": {
		"artist": "Listen to {artistName} on Qobuz",
		"album": "Listen to the album {albumName} by {albumName} on Qobuz",
		"track": "Listen to {trackName} by {artistName} on Qobuz",
		"playlist": "Listen to the playlist {playlistName} by {ownerName} on Qobuz",
		"story": "Read this Article on Qobuz"
	},
	"buttons": {
		"listen": "Listen on Qobuz",
		"buy": "Buy",
		"share": "Share",
		"download": "Try for free",
		"readmore": "Read more",
		"showless": "Show less",
		"showmore": "See more",
		"morealbums": "More albums on Qobuz",
		"moreplaylisttrack": "Discover the rest on Qobuz",
		"readfocus": "Read this Panorama on Qobuz",
		"seeSubscribes": "See the subscription offers",
		"cookies": "Cookie settings"
	},
	"infos": {
		"trackCount": "{count} tracks",
		"label": "Label: {label}",
		"composer": "Composer: {composer}",
		"producers": "Production",
		"mixers": "Mixing/mastering",
		"diskCount": "{count} albums",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Private",
			"public": "Public"
		},
		"hires": "High quality",
		"available": "Available in"
	},
	"share": {
		"twitter": {
			"track": "Listen to {title} by {artist} on Qobuz",
			"album": "Listen to {title} by {artist} on Qobuz",
			"artist": "Listen to {artist} on Qobuz",
			"playlist": "Listen to {playlist} by {owner} on Qobuz",
			"story": "Read this article on Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} by {artist} is available on Qobuz!",
				"body": "Listen to {title} by {artist} with Qobuz in high quality: {url}\n\nQobuz is the first musical streaming and download service in high quality.\nFor more information and to sign up go to Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} by {artist} is available on Qobuz!",
				"body": "Listen to {title} by {artist} with Qobuz in high quality: {url}\n\nQobuz is the first musical streaming and download service in high quality.\nFor more information and to sign up go to Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} is on Qobuz!",
				"body": "Listen to {artist} with Qobuz in high quality: {url}\n\nQobuz is the first musical streaming and download service in high quality.\nFor more information and to sign up go to Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} by {owner} is available on Qobuz!",
				"body": "Listen to {playlist} by {owner} with Qobuz in high quality: {url}\n\nQobuz is the first musical streaming and download service in high quality.\nFor more information and to sign up go to Qobuz.com\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "Play {url}\n\nQobuz is the first musical streaming and download service in high quality.\nFor more information and to sign up go to Qobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "Click to copy",
			"copy": "Copy",
			"copied": "Copied",
			"link": "Copy the following link to share it"
		}
	},
	"tracklist": {
		"title": {
			"track": "Song",
			"album": "Album tracks",
			"artist": "Top tracks",
			"artist_albums": "Albums",
			"playlist": "Tracks on the playlist"
		},
		"header": {
			"number": "#",
			"name": "Track",
			"album": "Album",
			"artist": "Artist",
			"time": "Length",
			"label": "Label"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "No tracks available"
	},
	"story": {
		"404": {
			"title": "The article you have requested does not exist in your geographical area.\n",
			"description": "Return to the Qobuz magazine home page"
		},
		"from": "By {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Join Qobuz to read the full article",
		"signUp": "Try for free"
	},
	"playlist": {
		"from": "By {author}"
	},
	"album": {
		"by": "by",
		"publishedBy": "released by"
	},
	"notifications": {
		"nostream": "The rights-holders have not made it possible to listen to this track"
	},
	"aside": {
		"title": "About"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 566
// module chunks = 0